<template lang="html">
  <div class="modal-card" style="width: auto" v-if="currentUser">
    <header class="modal-card-head">
      <p class="modal-card-title">Upload Images</p>
    </header>

    <section class="modal-card-body">
      <div class="has-text-centered">
        <b-field>
          <b-upload
            v-model="images"
            multiple
            drag-drop
            accept="image/*"
            @input="setupCaptions"
          >
            <section class="section">
              <div class="content has-text-centered">
                <p>
                  <b-icon icon="upload" size="is-large"> </b-icon>
                </p>
                <p>Drop your images here or click to upload</p>
              </div>
            </section>
          </b-upload>
        </b-field>

        <div v-for="(image, index) in images" :key="index" class="columns is-vcentered">
          <div class="column is-1 is-paddingless pl-3">
            <figure class="image is-square">
              <img
                :src="getImageURL(image)"
                style="border-radius: 10%"
                alt="Placeholder image"
              />
            </figure>
          </div>
          <div class="column is-10">
            <span class="ellipsis">{{ image.name }}</span>
          </div>

          <div class="column is-1">
            <button class="delete" type="button" @click="deleteImage(index)"></button>
          </div>
        </div>
      </div>
    </section>

    <footer class="modal-card-foot">
      <span class="card-footer-item">
        <b-button @click="$parent.close()"> Cancel </b-button>
      </span>

      <span class="card-footer-item">
        <b-button type="is-primary" @click="uploadImages"> Upload </b-button>
      </span>
    </footer>

    <!-- Loaders -->
    <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { notificationMixin } from '@/mixins/notificationMixin.js'
export default {
  mixins: [notificationMixin],
  props: ['imageableId', 'imageableType'],
  data () {
    return {
      images: [],
      captions: [],
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser'
    })
  },
  methods: {
    getImageURL (image) {
      return URL.createObjectURL(image)
    },
    deleteImage (index) {
      this.images.splice(index, 1)
      this.captions.splice(index, 1)
    },
    setupCaptions (images) {
      images.slice(this.captions.length).forEach((_) => {
        this.captions.push('')
      })
    },
    uploadImages () {
      this.isLoading = true
      let fd = new FormData()
      this.images.forEach((element, index) => {
        fd.append(`images[]`, element, element.name)
      })
      this.captions.forEach((element, index) => {
        fd.append(`captions[]`, element)
      })
      this.$store
        .dispatch('images/create', {
          imageableId: this.imageableId,
          imageableType: this.imageableType,
          payload: fd
        })
        .then((resp) => {
          this.$emit('imagesUpdated', resp.data.data)
          this.actionSuccess('Your images were successfuly uploaded !')
          this.isLoading = false
          this.$parent.close()
        })
        .catch((error) => {
          // TODO: Handle error properly
          console.log(error.response)
          this.$buefy.dialog.alert({
            title: 'Error',
            message:
              "Something's not good but I have a custom <b>icon</b> and <b>type</b>",
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>
